import { render, staticRenderFns } from "./AchievementSimulation.vue?vue&type=template&id=953855b8&scoped=true&"
import script from "./AchievementSimulation.vue?vue&type=script&lang=js&"
export * from "./AchievementSimulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953855b8",
  null
  
)

export default component.exports